import PartnerPDPLandingPage from './PartnerPDPLandingPage'

export default PartnerPDPLandingPage
